import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'userNotificationsFilterGroup' })
export class UserNotificationsFilterGroupPipe implements PipeTransform {
  transform(value: any[], args?: any): any {
    return value.filter((item: any) => item.group === args);
  }
}
